import MicroIframe from 'micro-frontend-iframe';
import React from 'react';
import ReactDOM from 'react-dom';
import BarLoader from 'react-spinners/ClipLoader';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from 'serviceWorker';
import { Reset } from 'styled-reset';
import styled from 'styled-components';
import { firebase } from './system/model/firebase/firebase';
import configureStore from './redux/reducer';
import App from './app';
import { PlatformExeptions } from './system/helpers/main';
import { startSetSkills } from './redux/actions/initializer_actions';
import { startSetCompany, startSetPlatform } from './redux/actions/platformAction';
import { palette } from './system/styles/styles';
import { companyLogin, logout } from './redux/actions/auth_actions';
import history from './system/router/history';
import unisATSRoutes from './system/router';
import './i18n/i18n';
import 'react-quill/dist/quill.snow.css';

const LoadContainer = styled.main`
  .rel {
    position: relative;
  }
  .full {
    width: 100vw;
    height: 100vh;
  }
  .above-center {
    position: absolute;
    top: 40%;
    left: 45%;
    transform: translate(-40%, -45%);
    h4 {
      font-family: ${palette.nereg};
      letter-spacing: 0.5px;
      font-size: 18px;
    }
  }
  .real-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
const store = configureStore();
MicroIframe.init('BIF-ATS-APP');

const jsx = (
  <Provider store={store}>
    <Reset />
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
const hasRendered = false;
const min = 1;
const max = 15;
const random = Math.floor(Math.random() * (+max - +min)) + +min;
const amusing = [
  'Paciencia… La espera valdrá la pena. ⏰',
  '¡Un momento por favor! Tu solicitud se está horneando. 👨‍🍳',
  'Paciencia... ¡Nos estamos convirtiendo en unicornio! 🦄',
  '¡Espera un poco, un poquiiiiiiito más! Programando andamos. 🖥',
  '¿Hace cuánto que no te levantas de esa silla? Aprovecha estos segundos para estirar. 🙆🙆‍♀️‍',
  'Espera, ¡Estamos analizando tu buena vibra! 👀',
  'No se trata de esperar, ¡Se trata de vivir! 👈',
  '¿Cuántas sonrisas llevas el día de hoy? Aprovecha este momento para sonreír.😀',
  'Todo es posible, incluso acabar con tu burnout. 😉',
  'Sabías qué... Un unicornio es una startup valorada en más de 1,000 millones de USD. 🦄',
  'Cosas buenas llegan para quienes saben esperar... 🕢',
  'Este es el momento perfecto para intentar eso a lo que le temes.👻',
  'Dicen que lo bueno tarda en llegar...🥸',
  'Cargando el mensaje de carga… ⏳',
  '¡Danos un segundito más! Ya casi estamos ahí...🕢',
];

const renderApp = () => {
  if (!hasRendered) {
    ReactDOM.render(jsx, document.getElementById('unis-ats-root'));
  }
};

const loading = (
  <LoadContainer>
    <div className="rel full">
      <div className="above-center">
        <h4 className="text-center">{amusing[random]}</h4>
      </div>
      <div className="real-center">
        <BarLoader sizeUnit="px" height={5} width={750} color={palette.blue} />
      </div>
    </div>
  </LoadContainer>
);

ReactDOM.render(loading, document.getElementById('unis-ats-root'));

async function callback(user) {
  // ReactDOM.render(loading, document.getElementById('unis-ats-root'));
  //
  try {
    if (user) {
      await firebase.auth().currentUser.getIdToken(true);
      const idTokenResult = await firebase.auth().currentUser.getIdTokenResult();
      if (
        idTokenResult?.claims?.typeuser === 'company' &&
        idTokenResult?.claims?.segment?.toUpperCase() === store?.getState()?.platform?.platformName?.toUpperCase()
      ) {
        // Se valida que este en entorno de producción en caso de estar en entorno de desarrollo se carga la informacion de demo
        const urlDomain = (document.referrer || window.location.href).includes('localhost')
          ? 'https://demo-universidades.lapieza.io/'
          : document.referrer || window.location.href;
        // Se extrae el subdominio para poder proceder a cargar la informacion de la plataforma, con base en el ejeplo el valor seria mondragon
        let platformName = urlDomain?.includes('lapieza.io')
          ? urlDomain.substring(urlDomain.lastIndexOf('//') + 2, urlDomain.lastIndexOf('.l'))
          : urlDomain.substring(urlDomain.lastIndexOf('//') + 2);
        const existSlash = platformName.indexOf('/');
        platformName = platformName.substring(0, existSlash === -1 ? platformName.length : existSlash);
        const platform = PlatformExeptions(platformName);
        await store.dispatch(
          companyLogin(user.uid, idTokenResult.claims.typeuser, user, idTokenResult.claims, platform)
        );
        await store.dispatch(startSetCompany());
        if (window.location.pathname === '/') {
          history.push(`${unisATSRoutes.VACANCIES}`);
        }
        setTimeout(() => {
          renderApp();
        }, 2000);
      } else {
        store.dispatch(logout());
        history.push(`${unisATSRoutes.MAIN}`);
        setTimeout(() => {
          renderApp();
        }, 2000);
      }
    } else {
      history.push(`${unisATSRoutes.MAIN}`);
      setTimeout(() => {
        renderApp();
      }, 2000);
    }
  } catch (e) {
    history.push(`${unisATSRoutes.MAIN}`);
    setTimeout(() => {
      renderApp();
    }, 2000);
  }
}
// Carga de toda la información de la  plataforma con base en el dominio ejemplo https://mondragon.lapieza.io
const loadPlatform = async () => {
  // Se valida que este en entorno de producción en caso de estar en entorno de desarrollo se carga la informacion de demo
  const urlDomain = (document.referrer || window.location.href).includes('localhost')
    ? 'https://demo-universidades.lapieza.io/'
    : document.referrer || window.location.href;
  // Se extrae el subdominio para poder proceder a cargar la informacion de la plataforma, con base en el ejeplo el valor seria mondragon
  let platformName = urlDomain?.includes('lapieza.io')
    ? urlDomain.substring(urlDomain.lastIndexOf('//') + 2, urlDomain.lastIndexOf('.l'))
    : urlDomain.substring(urlDomain.lastIndexOf('//') + 2);
  const existSlash = platformName.indexOf('/');
  platformName = platformName.substring(0, existSlash === -1 ? platformName.length : existSlash);
  // Algunas plataformas solicitaron un cambio en el nombre de dominios la funcion PlatformExeptions(exeption) se encarga de manipular esas exepciones
  const platform = PlatformExeptions(platformName);
  await store.dispatch(startSetPlatform(platform));
  await store.dispatch(startSetSkills());
  firebase.auth().onAuthStateChanged(callback);
};
serviceWorker.unregister();
loadPlatform().then();
